import { TEMPLATES_TRACKING_EDITOR } from 'src/constants/templates';

export const trackingList = (templateTitle, button1, button2) => {
  let tracking_editor = TEMPLATES_TRACKING_EDITOR?.[templateTitle];
  let button1_list = `[`;
  for (let i = 0; i < tracking_editor?.length; i++) {
    // if (button1.hasOwnProperty(tracking_editor[i]))
    button1_list += `${JSON.stringify(button1?.[tracking_editor[i]])},`;
  }
  button1_list += ']';

  let button2_list = `[`;
  for (let i = 0; i < tracking_editor?.length; i++) {
    // if (button2.hasOwnProperty(tracking_editor[i]))
    button2_list += `${JSON.stringify(button2?.[tracking_editor[i]])},`;
  }
  button2_list += ']';

  // console.log([button1_list, button2_list]);
  // console.log('test');

  return [button1_list, button2_list];
};
